import React from 'react';
import './Skeleton.css';

const Skeleton = ({ width, height, style, className = '' }) => (
  <div
    className={`skeleton ${className}`}
    style={{ width, height, ...style }}
  />
);

export default Skeleton; 